import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferCharges {
  constructor($scope, OfferService, UserService) {
    $scope.tabs = [
      {
        title: 'By Delivery Term'
      },
      {
        title: 'By Country'
      },
      {
        title: 'By User'
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };

    $scope.check_items = function(is_reels) {
      angular.forEach($scope.items, function(item) {
        if (is_reels && item.is_reels)
          item.checked = $scope.reels_checked;
        else if (!is_reels && !item.is_reels)
          item.checked = $scope.sheets_checked;
      });
    };

    $scope.get_stocklist = function() {
      $scope.previous_items = angular.copy($scope.items);
      $scope.items = [];
      $scope.loading = true;
      OfferService.get_stocklist_for_charges(window.offer_id).then(function(data) {
        $scope.items = data.items;
        $scope.has_reels = _.select(data.items, function(i) {
          return i.is_reels === true;
        }).length > 0;
        $scope.has_sheets = _.select(data.items, function(i) {
          return i.is_reels === false;
        }).length > 0;
        $scope.loading = false;
        angular.forEach($scope.items, function(item) {
          var previous_item = _.find($scope.previous_items, function(i) {
            return item.id == i.id;
          });
          if (previous_item && previous_item.checked)
            item.checked = true;
        });
      });
    };

    $scope.apply_charge = function() {
      var items = [];
      angular.forEach($scope.items, function(item) {
        if (item.checked)
          items.push({
            id: item.id,
            charge: $scope.charge,
            term: $scope.charge_term
          });
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.applying_charges = true;
        OfferService.set_item_term_charges(window.offer_id, items).then(function(data) {
          if (data.success) {
            $scope.applying_charges = false;
            $scope.get_stocklist();
          }
        });
      }
    };

    $scope.$watch('continent', function() {
      $scope.countries = [];
      if ($scope.continent && $scope.continent !== '') {
        var group = $('select#countries').find('optgroup[label="' + $scope.continent + '"]');
        group.find('option').each(function() {
          $scope.countries.push($(this).attr('value'));
        });
      }
    });

    $scope.apply_country_charge = function() {
      if ($scope.countries.length === 0) {
        alert('Please select at least one country!');
      } else {
        $scope.applying_country_charges = true;
        OfferService.set_offer_country_charges(window.offer_id, $scope.country_charge, $scope.countries).then(function(data) {
          if (data.success) {
            $scope.applying_country_charges = false;
            $scope.country_charges = data.country_charges;
            $scope.preview_data = null;
          }
        });
      }
    };

    $scope.delete_country_charge = function(charge_id) {
      OfferService.delete_country_charge(window.offer_id, charge_id).then(function(data) {
        if (data.success) {
          $scope.country_charges = data.country_charges;
          $scope.preview_data = null;
        }
      });
    };

    $scope.preview_country_charge = function(country_charge) {
      $scope.preview_data = country_charge;
    };

    $scope.filter_supplier_country_charges = function(charge) {
      return typeof(_.findWhere($scope.country_charges, {
        country_id: charge.country_id
      })) == 'undefined';
    };

    function set_user_company_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.user_charge.user_id = ui.item.id;
          $scope.buyer_user_company = ui.item.value;
          $(this).val('');
          $scope.$apply();
        }
      });
    }

    $scope.remove_user = function() {
      $scope.user_charge.user_id = null;
      $scope.buyer_user_company = null;
      $('input.user_company').val('');
    };

    function get_user_charge() {
      return {
        offer_id: window.offer_id,
        user_id: null,
        charge: 0
      };
    }

    $scope.add_user_charge = function() {
      if (!$scope.user_charge.user_id) {
        alert('Please select a buyer!');
        return false;
      }
      if ($scope.user_charge.charge === 0) {
        alert('Please input a valid charge!');
        return false;
      }
      if (_.findWhere($scope.user_charges, {user_id: $scope.user_charge.user_id})) {
        alert('User has an existing charge!');
        return false;
      }
      $scope.adding_user_charge = true;
      OfferService.save_user_charge($scope.user_charge).success(function(data) {
        if (data.success) {
          $scope.user_charges = data.user_charges;
          $scope.adding_user_charge = false;
          $scope.remove_user();
        }
      });
    };

    $scope.edit_user_charge = function(user_charge) {
      $scope.dialog_user_charge = angular.copy(user_charge);
      $.fancybox($('div#edit_user_charge'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    };

    $scope.update_user_charge = function() {
      OfferService.save_user_charge($scope.dialog_user_charge).success(function(data) {
        if (data.success) {
          $scope.user_charges = data.user_charges;
          $.fancybox.close();
        }
      });
    };

    $scope.delete_user_charge = function(user_charge) {
      OfferService.delete_user_charge(user_charge.id).success(function(data) {
        if (data.success)
          $scope.user_charges.splice(_.indexOf($scope.user_charges, user_charge), 1);
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.offer_id = window.offer_id;
      $scope.show_fca = true;
      $scope.show_fas = false;
      $scope.show_cfr = false;
      $scope.show_dap = false;
      $scope.show_fob = false;
      $scope.charge_term = 3;
      $scope.charge = 0;
      $scope.items = [];
      $scope.get_stocklist();
      $scope.countries = [];
      $scope.country_charges = window.country_charges;
      $scope.supplier_country_charges = window.supplier_country_charges;
      $scope.user_charges = window.user_charges;
      $scope.user_charge = get_user_charge();
      set_user_company_autocomplete($('input.user_company'));
    };

    $scope.init();
  }
}

OfferCharges.$inject = ['$scope', 'OfferService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-charges.ctrl.js